import React, { useContext, useState } from 'react';

import { Box, FormControlLabel, makeStyles, Radio, RadioGroup } from '@material-ui/core';

import ScreenTextContext from '../../contexts/ScreenTextContext';
import { MODES } from '../../utils/constants';

import { BackNextButtons } from './BackNextButtons';
import { RadioToggle } from '.';

const modes = [ MODES.MELTDOWN, MODES.QUICK_PLAY, MODES.LECTURE ];

const useStyles = makeStyles( (theme) => {
  const styles = {
    radioGroup: {
      flexDirection: 'row',
      margin: '3rem -1.5rem 0',
      width: 'calc(100% + 3rem)',
      [theme.breakpoints.up('lg')]: {
        margin: '0 -2rem',
        flexWrap: 'nowrap',
        width: 'calc(100% + 4rem)',
      },
      [theme.breakpoints.up('xl')]: {
        margin: '0 -3.3rem',
        width: 'calc(100% + 6.6rem)',
      }
    },
    radioLabel: {
      margin: '1.5rem',
      border: '3px solid ' + theme.palette.navyLight1,
      borderRadius: '5rem 0',
      flex: '1 1 100%',
      alignItems: 'flex-start',
      color: '#fff',
      padding: '3rem 2rem',
      background: theme.palette.navyDark3,
      fontFamily: 'museo-sans',
      textAlign: 'left',
      [theme.breakpoints.up('lg')]: {
        flex: '1 1 50%',
        margin: '1.5rem',
      },
      [theme.breakpoints.up('xl')]: {
        margin: '1.3rem',
      },
      '& .mode__label-title': {
        fontSize: '3.2rem',
        lineHeight: '3.8rem',
        fontWeight: 700,
        paddingLeft: '1rem',
        marginBottom: '1rem',
      },
      '& .mode__label-description': {
        fontSize: '1.8rem',
        lineHeight: '2.8rem',
        letterSpacing: '.01em',
        fontWeight: 500,
        paddingLeft: '1rem',
      }
    },
    icon: {
      height: '2.8rem',
      width: '2.8rem',
      border: '#FFF 2px solid',
      borderRadius: '50%',
    },
    checkedIcon: {
      borderWidth: 7,
      background: theme.palette.navyDark1
    }
  }

  modes.forEach(mode => {
    styles.radioLabel[`&.${mode}:hover`] = {
      background: theme.palette[mode].light,
      borderColor: theme.palette[mode].light,
    }
    styles.radioLabel[`&.${mode}.active`] = {
        borderColor: theme.palette[mode].light,
        background: theme.palette[mode].dark,
    }
  })
  
  return styles;
});

export const ChooseMode = ({changeStep, mode, role, setMode, setRole }) => {
  
  const [selectedMode, setSelectedMode] = useState(mode || null);
  const [selectedRole, setSelectedRole] = useState(role || "ER");

  const classes = useStyles();


  // Load screen text
  const { screenText } = useContext(ScreenTextContext);  

  if (!screenText || !screenText.setUp || !screenText.global) {
    return ''; // Should return error? Loading?
  }
  
  const { mode : modeText } = screenText.setUp;
  const { modes : modesText, roles: rolesText } = screenText.global;


  // Button handlers
  const handleChange = (e) => {
    setSelectedMode(e.target.value);
  }

  const handleBack = () => {
    changeStep.backward();
    setMode(selectedMode);
    setRole(selectedRole);
  }

  const handleNext = () => {
    changeStep.forward();
    setMode(selectedMode);
    setRole(selectedRole);
  }

  return (
    <div className="mode page-container">

      <div className="set-up__container set-up__container--min-height">

        <h1 className="mode__title h2">{modeText.title}</h1>
        
        {/* Choose Role */}
        <Box margin="45px auto">
          <RadioToggle
            hideLabel={true}
            label={modeText.roleLabel}
            name="role"
            setValue={setSelectedRole}
            value={selectedRole}
            options={Object
              .keys(rolesText)
              .map(role => ({
                value: role,
                label: rolesText[role].fullTitle
              }))
              .sort((a,b) => (a.label < b.label))
            }
            width="auto"
          />
        </Box>


        {/* Choose Mode */}
        <fieldset className="w-100">

          <legend className="sr-only">{modeText.modeLabel}</legend>

          <RadioGroup className={classes.radioGroup} name="mode" value={selectedMode} onChange={(handleChange)}>
            {modes.sort().map((mode, i) => (
              <FormControlLabel 
                key={i} 
                className={`${classes.radioLabel} ${mode} ${selectedMode === mode ? 'active' : ''} `} 
                value={mode} 
                label={
                  <div>
                    <div className="mode__label-title">{modesText[mode].title}</div>
                    <div className="mode__label-description">{modesText[mode].description}</div>
                  </div>
                } 
                control={
                  <Radio 
                    checkedIcon={<span className={classes.icon + ' ' + classes.checkedIcon} />}
                    icon={<span className={classes.icon} />}
                  />
                } 
              />
            ))}
          </RadioGroup>

        </fieldset>
      
      </div>

      <BackNextButtons handleBack={handleBack} handleNext={handleNext} disableNext={!selectedMode || !selectedRole} />

    </div>
  )
}